module.exports = __webpack_public_path__ + "img/tel.ec67e212.jpg";